import { Component, OnInit, OnDestroy } from '@angular/core';
import {Router} from "@angular/router";
import { WebsocketService } from '../../services/websocket.service';
import { filter, Subscription } from 'rxjs';
import {ControllerCardComponent} from "../controller-card/controller-card.component";
import {HttpClientModule} from "@angular/common/http";
import {NgFor, NgIf} from "@angular/common";
import { TranslatePipe } from '@ngx-translate/core';
import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-controller-list',
  templateUrl: './controller-list.component.html',
  styleUrls: ['./controller-list.component.scss'],
  standalone: true,
  imports: [TranslatePipe, ControllerCardComponent,
    HttpClientModule,
    NgFor, NgIf,
    CdkDropList, CdkDrag, CdkDragHandle
  ]
})

export class ControllerListComponent implements OnInit, OnDestroy {  
  controllers: any[] = [];
  sortedControllers: any[] = [];
  isOnline: boolean = false;
  private connSub: Subscription | null = null;
  private msgSub: Subscription | null = null;
  private devSub: Subscription | null = null;
  reorderMode = false;
  private orderBefore: string[] = [];

  constructor(private router: Router,
              private websocketService: WebsocketService) {}

  ngOnInit() {    
    // Subscribe to websocket connection status
    this.connSub = this.websocketService.isConnected$.subscribe((status: boolean) => {
      this.isOnline = status;      
    });

    this.devSub = this.websocketService.getUserDevices().subscribe((data: any) => {
      if (data != null) {
        this.controllers = data;
        // The server returns devices already in the user's saved order (User.deviceOrder),
        // unordered ones after them by name — so keep the order as received.
        // Don't clobber an arrangement the user is in the middle of editing.
        if (!this.reorderMode) this.sortedControllers = [...this.controllers];
      }
    });

    // Subscribe to WebSocket messages to update controller status
    this.msgSub = this.websocketService.messages$.pipe(
      filter((message: any) => message && message.type === 'STATUS')
    ).subscribe((message: any) => {
      // STATUS прилетает по одному контроллеру (online/offline)
      
      const mac = message?.payload?.mac;
      const online = message?.payload?.online;
      if (!mac) return;

      // Find controller in controllers list by mac
      const direct = message?.payload?.directConnected;
      const idx = this.controllers.findIndex((c: any) => c && (c.mac === mac || c.deviceMac === mac));
      if (idx !== -1) {
        this.controllers[idx].online = online;
        if (direct !== undefined) this.controllers[idx].directConnected = direct;
        const sidx = this.sortedControllers.findIndex((c: any) => c && (c.mac === mac || c.deviceMac === mac));
        if (sidx !== -1) {
          this.sortedControllers[sidx].online = online;
          if (direct !== undefined) this.sortedControllers[sidx].directConnected = direct;
        }
      }
    });      
  }
  
  ngOnDestroy() {
    if (this.connSub) this.connSub.unsubscribe();
    if (this.msgSub) this.msgSub.unsubscribe();
    if (this.devSub) this.devSub.unsubscribe();
  }

  goToDetails(mac: string) {
    this.router.navigate(['/controller', mac]);
  }

  // --- Reordering -------------------------------------------------------------------------

  startReorder() {
    this.orderBefore = this.macs();
    this.reorderMode = true;
  }

  cancelReorder() {
    const pos = new Map(this.orderBefore.map((m, i) => [m, i] as [string, number]));
    this.sortedControllers = [...this.sortedControllers].sort(
      (a, b) => (pos.get(a.mac) ?? 1e9) - (pos.get(b.mac) ?? 1e9));
    this.reorderMode = false;
  }

  finishReorder() {
    this.reorderMode = false;
    const order = this.macs();
    if (order.join(',') === this.orderBefore.join(',')) return;
    this.websocketService.sendMessage({ type: 'SETDEVICEORDER', payload: { order } });
  }

  onDrop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.sortedControllers, event.previousIndex, event.currentIndex);
  }

  move(index: number, delta: number) {
    const to = index + delta;
    if (to < 0 || to >= this.sortedControllers.length) return;
    moveItemInArray(this.sortedControllers, index, to);
  }

  private macs(): string[] {
    return this.sortedControllers.map((c: any) => c.mac).filter((m: any) => !!m);
  }

}
